export default __webpack_public_path__ + "static/media/network-modal-character.1e248fd1.png";